import { MenuItem, Snackbar, TextField } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../store/auth-context";
import { userService } from "../../services/UserService";
import { Alert } from "@material-ui/lab";

function UpdateInterestedUsersStatus(props: any) {
  const [status, setStatus] = useState<string>("New");
  const [comment, setComment] = useState<string>("");
  const [offerInterestId, setOfferInterestId] = useState<number>(0);
  const authCtx = useContext(AuthContext);

  const statusList = [
    {
      name: "New",
      value: "New",
    },
    {
      name: "Contacted",
      value: "Contacted",
    },
    {
      name: "Interested",
      value: "Interested",
    },
    {
      name: "Not Interested",
      value: "Not Interested",
    },
    {
      name: "Converted",
      value: "Converted",
    },
    {
      name: "Closed - Lost",
      value: "Closed - Lost",
    },
    {
      name: "Other",
      value: "Other",
    },
  ];

  useEffect(() => {
    setStatus(
      props.interestedUserEditItem.status
        ? props.interestedUserEditItem.status
        : "New"
    );
    setComment(
      props.interestedUserEditItem.comment
        ? props.interestedUserEditItem.comment
        : ""
    );
    setOfferInterestId(
      props.interestedUserEditItem.offerInterestId
        ? props.interestedUserEditItem.offerInterestId
        : 0
    );
  }, []);

  const handleStatusUpdate = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.updateInterestedUserStatus(
      offerInterestId,
      status,
      comment
    );
    if (res?.message?.status === "Success") {
      const filteredUser = props.usersList.find(
        (item: any) => item.offerInterestId === offerInterestId
      );
      if (filteredUser) {
        props.setusersList(
          props.usersList.map((item: any) =>
            item.offerInterestId === offerInterestId
              ? { ...filteredUser, status: status, modifiedByName: "Test User" }
              : item
          )
        );
      }
      props.setModalText(res.message.message);
      props.setModalType("success");
      props.setShowModal(true);
      props.handleEditModalClose();
    } else {
      props.setModalText("Something went wrong!");
      props.setModalType("error");
      props.setShowModal(true);
    }
    authCtx.toggleLoader(false);
  };

  return (
    <>
      <div className="row g-sm-3">
        <div className="col-sm mb-3">
          <TextField
            required
            select
            id="ticketType"
            label="Status"
            className="w-100  "
            variant="outlined"
            size="small"
            value={status}
            onChange={(e: any) => {
              setStatus(e.target.value);
            }}
          >
            {statusList &&
              statusList.map((item: any) => (
                <MenuItem value={item.value}>{item.name}</MenuItem>
              ))}
          </TextField>
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm mb-3">
          <TextField
            label="Comment"
            multiline
            className="w-100"
            size="small"
            rows={4}
            variant="outlined"
            value={comment}
            inputProps={{ maxLength: 250 }}
            onChange={(e: any) => {
              setComment(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="text-end modal-footer border-top-0 px-0">
        <button className="btn btn-primary" onClick={handleStatusUpdate}>
          Update
        </button>
      </div>
    </>
  );
}

export default UpdateInterestedUsersStatus;
